<template>
  <div>
    <b-card
      no-body
    >
      <div class="m-2">
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start"
          >
            <h5 class="mb-0 ml-50">
              모니터링 리스트 [{{ totalRecords }}] 건
            </h5>
          </b-col>
        </b-row>
      </div>
      <b-table
        ref="refResultTable"
        primary-key="id"
        :items="fetchList"
        :fields="tableColumns"
        :sort-by.sync="sortBy"
        :sort-desc.sync="isSortDesc"
        responsive
        sticky-header
        selectable
        select-mode="single"
        class="position-relative"
        @row-selected="onRowSelected"
      />
      <b-pagination
        v-model="currPage"
        :total-rows="totalRecords"
        limit="10"
        per-page="10"
        align="center"
      />
    </b-card>
    <b-card
      no-body
    >
      <div class="m-2">
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start"
          >
            <feather-icon
              icon="EditIcon"
              size="19"
            />
            <h4 class="mb-0 ml-50">
              상세
            </h4>
          </b-col>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-end"
          >
            <b-button
              variant="outline-primary"
              @click.stop="resetMonitoringData"
            >
              <feather-icon
                icon="PlusSquareIcon"
                class="mr-50"
              />
              <span>신규 등록</span>
            </b-button>
            <b-button
              variant="primary"
              class="ml-1"
              @click.stop="saveMonitoring"
            >
              <feather-icon
                icon="SaveIcon"
                class="mr-50"
              />
              <span>저장</span>
            </b-button>
            <b-button
              variant="outline-secondary"
              class="ml-1"
              @click.stop="removeMonitoring"
            >
              <feather-icon
                icon="Trash2Icon"
                class="mr-50"
              />
              <span>삭제</span>
            </b-button>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col>
            <b-alert
              variant="info"
              show
              class="mb-0"
            >
              <div class="alert-body">
                <h6 class="alert-heading mb-1">
                  모니터링 설정 안내
                </h6>
                <ul class="mb-0 pl-1">
                  <li>
                    <strong>닥터인포 약품정보 On/Off</strong>
                    <ul>
                      <li>임계값 기준: 고정값 사용, 고정값 미만 또는 초과로 설정 (택1)</li>
                    </ul>
                  </li>
                  <li>
                    <strong>닥터인포 자동실행</strong>
                    <ul>
                      <li>임계값 기준: 전일 기준 퍼센트 사용만 가능</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </b-alert>
          </b-col>
        </b-row>
        <!-- Edit Form -->
        <validation-observer ref="formRules">
          <b-row class="mt-1">
            <b-col
              cols="6"
              md="5"
            >
              <b-form-group
                label="모니터링 이름"
                label-for="monitoringName"
              >
                <validation-provider
                  #default="{ errors }"
                  name="모니터링 이름"
                  rules="required"
                >
                  <b-form-input
                    id="monitoringName"
                    v-model="monitoringData.name"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col
              cols="6"
              md="5"
            >
              <b-form-group
                label="설명"
                label-for="description"
              >
                <validation-provider
                  #default="{ errors }"
                  name="설명"
                  rules="required"
                >
                  <b-form-textarea
                    id="description"
                    v-model="monitoringData.description"
                    rows="3"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-1">
            <b-col
              cols="6"
              md="5"
            >
              <b-form-group
                label="모니터링 유형"
                label-for="monitoringType"
              >
                <validation-provider
                  #default="{ errors }"
                  name="모니터링 유형"
                  rules="required"
                >
                  <v-select
                    v-model="monitoringData.monitoringType"
                    :options="codes.monitoringType"
                    class="el-def"
                    placeholder="선택"
                    :reduce="option => option.code"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col
              cols="6"
              md="5"
            >
              <b-form-group
                label="조회 기준"
                label-for="countingType"
              >
                <validation-provider
                  #default="{ errors }"
                  name="조회 기준"
                  rules="required"
                >
                  <v-select
                    v-model="monitoringData.countingType"
                    :options="codes.countingType"
                    class="el-def"
                    placeholder="선택"
                    :reduce="option => option.code"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-1">
            <b-col
              cols="6"
              md="5"
            >
              <b-form-group
                label="임계값 조건"
                label-for="thresholdType"
              >
                <validation-provider
                  #default="{ errors }"
                  name="임계값 조건"
                  rules="required"
                >
                  <v-select
                    v-model="monitoringData.thresholdType"
                    :options="codes.thresholdType"
                    class="el-def"
                    placeholder="선택"
                    :reduce="option => option.code"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col
              cols="6"
              md="5"
            >
              <b-form-group
                label="임계값 기준"
                label-for="thresholdValueType"
              >
                <validation-provider
                  #default="{ errors }"
                  name="임계값 기준"
                  rules="required"
                >
                  <v-select
                    v-model="monitoringData.thresholdValueType"
                    :options="codes.thresholdValueType"
                    class="el-def"
                    placeholder="선택"
                    :reduce="option => option.code"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-1">
            <b-col
              cols="6"
              md="5"
            >
              <b-form-group
                label="임계값(N)"
                label-for="thresholdValue"
              >
                <validation-provider
                  #default="{ errors }"
                  name="임계값"
                  rules="required"
                >
                  <b-form-input
                    id="thresholdValue"
                    v-model="monitoringData.thresholdValue"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col
              cols="6"
              md="5"
            >
              <b-form-group
                label="진료과(MediDeptCode로 입력, ex. 진료과 전체:0, 내과:1)"
                label-for="medicalDepartmentCode"
              >
                <validation-provider
                  #default="{ errors }"
                  name="진료과"
                  rules="required"
                >
                  <b-form-input
                    id="medicalDepartmentCode"
                    v-model="monitoringData.medicalDepartmentCode"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-1">
            <b-col
              cols="6"
              md="5"
            >
              <b-form-group
                label="사용 여부"
                label-for="isUse"
              >
                <validation-provider
                  #default="{ errors }"
                  name="사용 여부"
                  rules="required"
                >
                  <b-form-radio-group
                    v-model="monitoringData.isUse"
                    name="isUse"
                  >
                    <b-form-radio
                      class="custom-control-primary"
                      :value="true"
                    >
                      사용함
                    </b-form-radio>
                    <b-form-radio
                      class="custom-control-secondary"
                      :value="false"
                    >
                      사용안함
                    </b-form-radio>
                  </b-form-radio-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-1">
            <b-col
              cols="6"
              md="5"
            >
              <b-form-group
                label="등록일"
                label-for="createDate"
              >
                <b-form-input
                  id="createDate"
                  v-model="monitoringData.createDate"
                  readonly
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="6"
              md="5"
            >
              <b-form-group
                label="수정일"
                label-for="modifyDate"
              >
                <b-form-input
                  id="modifyDate"
                  v-model="monitoringData.modifyDate"
                  readonly
                />
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
      </div>
    </b-card>
    <b-card
      no-body
    >
      <div class="m-2">
        <b-row>
          <b-col
            cols="12"
            md="6"
          >
            <b-button
              variant="primary"
              class="btn-warning"
              @click.prevent="execMonitoringJob(1)"
            >
              전일 기준 닥터인포 모니터링 Job 실행
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import axios from '@axios'
import {
  ref, onMounted, watch, getCurrentInstance,
} from '@vue/composition-api'
import vSelect from 'vue-select'
import { useToast } from 'vue-toastification/composition'
import { required } from '@validations'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { errorFormatter } from '@core/utils/filter'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    vSelect,
    ValidationObserver,
    ValidationProvider,
  },

  setup() {
    onMounted(() => {
      fetchCodes()
    })

    const toast = useToast()
    const pushToast = (variant, title) => {
      let icon
      if (variant === 'success') {
        icon = 'CheckCircleIcon'
      } else {
        icon = 'AlertTriangleIcon'
      }

      toast({
        component: ToastificationContent,
        props: { title, icon, variant },
      })
    }
    const instance = getCurrentInstance()
    const refs = instance.proxy.$refs

    const codes = ref({
      monitoringType: [],
      countingType: [],
      thresholdType: [],
      thresholdValueType: [],
    })

    // Main Table Config
    const monitoringList = ref([])
    const dataInitState = {
      id: null,
      name: null,
      description: null,
      monitoringType: null,
      countingType: null,
      medicalDepartmentCode: null,
      thresholdType: null,
      thresholdValueType: null,
      thresholdValue: null,
      isUse: true,
      createUserId: null,
      createDate: null,
      modifyUserId: null,
      modifyDate: null,
    }
    const monitoringData = ref({ ...dataInitState })

    const resetMonitoringData = () => {
      Object.assign(monitoringData.value, dataInitState)
      refs.formRules.reset()
    }

    const refResultTable = ref(null)
    const sortBy = ref('createDate')
    const isSortDesc = ref(true)
    const currPage = ref(1)
    const totalRecords = ref(0)
    const tableColumns = [
      { key: 'id', label: 'ID', sortable: true },
      { key: 'name', label: '스케줄러 이름', sortable: true },
      { key: 'description', label: '설명', sortable: true },
      { key: 'isUse', label: '사용여부', sortable: true },
      { key: 'createDate', label: '등록일자', sortable: true },
      { key: 'modifyDate', label: '수정일자', sortable: true },
    ]
    const refetchData = () => {
      refResultTable.value.refresh()
    }
    watch([currPage], () => {
      refetchData()
    })
    const onRowSelected = items => {
      const item = items[0]
      if (item) {
        getData(item.id)
      }
    }
    // Main Table Config End.

    const fetchCodes = () => {
      axios.get('/fa/common/statistics/monitoring/codes')
        .then(rs => {
          const {
            monitoring_MonitoringType, monitoring_CountingType, monitoring_ThresholdType, monitoring_ThresholdValueType,
          } = rs.data
          codes.value.monitoringType = monitoring_MonitoringType
          codes.value.countingType = monitoring_CountingType
          codes.value.thresholdType = monitoring_ThresholdType
          codes.value.thresholdValueType = monitoring_ThresholdValueType
        })
        .catch(() => {
          pushToast('danger', '코드 데이터를 불러오는데 실패하였습니다.')
        })
    }

    const fetchList = (ctx, callback) => {
      axios.post('/fa/common/statistics/monitoring/list', {
        search: {
        },
        sort: {
          predicate: sortBy.value,
          reverse: isSortDesc.value,
        },
        pagination: {
          number: currPage.value,
        },
      })
        .then(rs => {
          const { items, totalRecord } = rs.data
          monitoringList.value = items
          callback(items)
          totalRecords.value = totalRecord
        })
        .catch(() => {
          pushToast('danger', '데이터 조회에 실패하였습니다.')
        })
    }

    const getData = id => {
      const found = monitoringList.value.find(i => i.id === id)
      if (found) {
        Object.assign(monitoringData.value, found)
      } else {
        resetMonitoringData()
      }
    }

    const saveMonitoring = () => {
      const validPromise = refs.formRules.validate()
      validPromise.then(valid => {
        if (!valid) return
        const { id } = monitoringData.value
        if (id) {
          updateMonitoring()
        } else {
          createMonitoring()
        }
      })
    }

    const createMonitoring = () => {
      const formdata = new FormData()

      formdata.append("name", monitoringData.value.name)
      formdata.append("description", monitoringData.value.description)
      formdata.append("monitoringType", monitoringData.value.monitoringType)
      formdata.append("countingType", monitoringData.value.countingType)
      formdata.append("medicalDepartmentCode", monitoringData.value.medicalDepartmentCode)
      formdata.append("thresholdType", monitoringData.value.thresholdType)
      formdata.append("thresholdValueType", monitoringData.value.thresholdValueType)
      formdata.append("thresholdValue", monitoringData.value.thresholdValue)
      formdata.append("isUse", monitoringData.value.isUse)

      axios.post('/fa/common/statistics/monitoring/new', formdata, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then(() => {
          pushToast('success', '신규 모니터링 등록 완료')
          refetchData()
        })
        .catch(error => {
          pushToast('danger', errorFormatter(error, '신규 모니터링 등록 과정에서 오류가 발생하였습니다.'))
        })
    }

    const updateMonitoring = () => {
      const formdata = new FormData()

      formdata.append("id", monitoringData.value.id)
      formdata.append("name", monitoringData.value.name)
      formdata.append("description", monitoringData.value.description)
      formdata.append("monitoringType", monitoringData.value.monitoringType)
      formdata.append("countingType", monitoringData.value.countingType)
      formdata.append("medicalDepartmentCode", monitoringData.value.medicalDepartmentCode)
      formdata.append("thresholdType", monitoringData.value.thresholdType)
      formdata.append("thresholdValueType", monitoringData.value.thresholdValueType)
      formdata.append("thresholdValue", monitoringData.value.thresholdValue)
      formdata.append("isUse", monitoringData.value.isUse)
      axios.post('/fa/common/statistics/monitoring/update', formdata, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then(() => {
          pushToast('success', '모니터링 변경 완료')
          refetchData()
        })
        .catch(error => {
          pushToast('danger', errorFormatter(error, '데이터를 변경하는 과정에서 오류가 발생하였습니다.'))
        })
    }

    const removeMonitoring = () => {
      if (!monitoringData.value.id) {
        pushToast('warning', '삭제할 대상을 선택하세요.')
        return
      }
      axios.delete(`/fa/common/statistics/monitoring/${monitoringData.value.id}`)
        .then(() => {
          pushToast('success', '데이터 삭제 완료')

          refetchData()
          resetMonitoringData()
        })
        .catch(() => {
          pushToast('danger', '데이터를 삭제하는 과정에서 오류가 발생하였습니다.')
        })
    }

    const execMonitoringJob = prevDay => {
      axios.patch(`/fa/common/statistics/monitoring/${prevDay}`)
        .then(rs => {
          toast({
            component: ToastificationContent,
            props: {
              title: '요청 완료',
              icon: 'CheckCircleIcon',
              variant: 'success',
            },
          })
        })
        .catch(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: '오류가 발생하였습니다.',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    }

    return {
      codes,
      tableColumns,
      refResultTable,
      sortBy,
      isSortDesc,
      refetchData,
      currPage,
      totalRecords,
      monitoringData,
      resetMonitoringData,
      onRowSelected,
      monitoringList,
      required,
      fetchList,
      getData,
      saveMonitoring,
      createMonitoring,
      updateMonitoring,
      removeMonitoring,
      execMonitoringJob,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
